module.exports = __webpack_public_path__ + "1ff9d2325ec91eb6e189a3b317017536.pdf";